import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { CheckCircle, XCircle, Loader } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VerifyEmailConfirm = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [errorMsg, setErrorMsg] = useState('');
  const { checkAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMsg('Token verifikasi tidak ditemukan.');
      return;
    }
    verifyToken();
  }, [token]);

  const verifyToken = async () => {
    try {
      await axios.get(`${API}/auth/verify-email?token=${token}`, { withCredentials: true });
      await checkAuth();
      setStatus('success');
      setTimeout(() => navigate('/dashboard'), 2500);
    } catch (e) {
      setStatus('error');
      setErrorMsg(e.response?.data?.detail || 'Verifikasi gagal. Link tidak valid atau sudah kadaluarsa.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6"
      style={{ background: 'linear-gradient(160deg, #EEF2FF 0%, #F0FDF4 100%)', fontFamily: "'IBM Plex Sans', sans-serif" }}>
      <div className="w-full max-w-md">

        <div className="bg-white/80 backdrop-blur-sm border border-blue-100 rounded-2xl shadow-lg p-10 text-center">

          {/* Loading */}
          {status === 'loading' && (
            <>
              <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
                style={{ background: 'linear-gradient(135deg, #EEF2FF, #DBEAFE)' }}>
                <Loader size={36} className="text-blue-600 animate-spin" />
              </div>
              <h1 className="text-2xl font-bold text-blue-900 mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Memverifikasi Email...
              </h1>
              <p className="text-slate-500 text-sm">Mohon tunggu sebentar.</p>
            </>
          )}

          {/* Success */}
          {status === 'success' && (
            <>
              <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
                <CheckCircle size={40} className="text-green-500" />
              </div>
              <h1 className="text-2xl font-bold text-blue-900 mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Email Terverifikasi! 🎉
              </h1>
              <p className="text-slate-500 text-sm leading-relaxed mb-6">
                Akun Anda berhasil diverifikasi. Anda akan diarahkan ke dashboard secara otomatis...
              </p>
              <div className="w-full bg-slate-100 rounded-full h-1.5 overflow-hidden">
                <div className="bg-green-500 h-1.5 rounded-full animate-pulse" style={{ width: '100%' }} />
              </div>
              <p className="text-xs text-slate-400 mt-3">Mengarahkan ke dashboard...</p>
            </>
          )}

          {/* Error */}
          {status === 'error' && (
            <>
              <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-6">
                <XCircle size={40} className="text-red-500" />
              </div>
              <h1 className="text-2xl font-bold text-blue-900 mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Verifikasi Gagal
              </h1>
              <p className="text-slate-500 text-sm leading-relaxed mb-6">{errorMsg}</p>
              <div className="flex flex-col gap-3">
                <Link to="/login"
                  className="w-full py-3 rounded-xl text-white font-semibold text-sm text-center"
                  style={{ background: 'linear-gradient(135deg, #1E3A8A, #3B82F6)' }}>
                  Coba Masuk
                </Link>
                <Link to="/register"
                  className="w-full py-3 rounded-xl border-2 border-blue-200 text-blue-700 font-semibold text-sm text-center hover:bg-blue-50 transition-colors">
                  Daftar Ulang
                </Link>
              </div>
            </>
          )}
        </div>

        <div className="flex items-center justify-center gap-2 mt-6">
          <img src="/logo.png" alt="RencanaGuru" className="h-7 w-7 object-contain" />
          <span className="font-bold text-blue-900 text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
            RencanaGuru<span className="text-yellow-500">.com</span>
          </span>
        </div>
      </div>
    </div>
  );
};
